/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/personGroupOperationsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a PersonGroupOperations. */
var PersonGroupOperations = /** @class */ (function () {
    /**
     * Create a PersonGroupOperations.
     * @param {FaceClientContext} client Reference to the service client.
     */
    function PersonGroupOperations(client) {
        this.client = client;
    }
    PersonGroupOperations.prototype.create = function (personGroupId, name, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            name: name,
            options: options
        }, createOperationSpec, callback);
    };
    PersonGroupOperations.prototype.deleteMethod = function (personGroupId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            options: options
        }, deleteMethodOperationSpec, callback);
    };
    PersonGroupOperations.prototype.get = function (personGroupId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            options: options
        }, getOperationSpec, callback);
    };
    PersonGroupOperations.prototype.update = function (personGroupId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            options: options
        }, updateOperationSpec, callback);
    };
    PersonGroupOperations.prototype.getTrainingStatus = function (personGroupId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            options: options
        }, getTrainingStatusOperationSpec, callback);
    };
    PersonGroupOperations.prototype.list = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, listOperationSpec, callback);
    };
    PersonGroupOperations.prototype.train = function (personGroupId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            options: options
        }, trainOperationSpec, callback);
    };
    return PersonGroupOperations;
}());
export { PersonGroupOperations };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var createOperationSpec = {
    httpMethod: "PUT",
    path: "persongroups/{personGroupId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    requestBody: {
        parameterPath: {
            name: "name",
            userData: [
                "options",
                "userData"
            ],
            recognitionModel: [
                "options",
                "recognitionModel"
            ]
        },
        mapper: __assign(__assign({}, Mappers.MetaDataContract), { required: true })
    },
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var deleteMethodOperationSpec = {
    httpMethod: "DELETE",
    path: "persongroups/{personGroupId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var getOperationSpec = {
    httpMethod: "GET",
    path: "persongroups/{personGroupId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    queryParameters: [
        Parameters.returnRecognitionModel
    ],
    responses: {
        200: {
            bodyMapper: Mappers.PersonGroup
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var updateOperationSpec = {
    httpMethod: "PATCH",
    path: "persongroups/{personGroupId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    requestBody: {
        parameterPath: {
            name: [
                "options",
                "name"
            ],
            userData: [
                "options",
                "userData"
            ]
        },
        mapper: __assign(__assign({}, Mappers.NameAndUserDataContract), { required: true })
    },
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var getTrainingStatusOperationSpec = {
    httpMethod: "GET",
    path: "persongroups/{personGroupId}/training",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.TrainingStatus
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var listOperationSpec = {
    httpMethod: "GET",
    path: "persongroups",
    urlParameters: [
        Parameters.endpoint
    ],
    queryParameters: [
        Parameters.start1,
        Parameters.top1,
        Parameters.returnRecognitionModel
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PersonGroup"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var trainOperationSpec = {
    httpMethod: "POST",
    path: "persongroups/{personGroupId}/train",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    responses: {
        202: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=personGroupOperations.js.map